import * as bs from "@platko/shared/locales/bs";
import * as en from "@platko/shared/locales/en";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["bs", "en"],
    defaultNS: "common",
    ns: [
      "common",
      "auth",
      "dashboard",
      "invoices",
      "invoiceDetail",
      "payment",
      "addresses",
      "analytics",
      "actions",
      "scraping",
      "settings",
      "meterReadings",
      "notFound",
      "components",
      "status",
      "adminSettings",
      "setup",
      "backendLogs",
    ],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        common: en.common,
        auth: en.auth,
        dashboard: en.dashboard,
        invoices: en.invoices,
        invoiceDetail: en.invoiceDetail,
        payment: en.payment,
        addresses: en.addresses,
        analytics: en.analytics,
        actions: en.actions,
        scraping: en.scraping,
        settings: en.settings,
        meterReadings: en.meterReadings,
        notFound: en.notFound,
        components: en.components,
        status: en.status,
        adminSettings: en.adminSettings,
        setup: en.setup,
        backendLogs: en.backendLogs,
      },
      bs: {
        common: bs.common,
        auth: bs.auth,
        dashboard: bs.dashboard,
        invoices: bs.invoices,
        invoiceDetail: bs.invoiceDetail,
        payment: bs.payment,
        addresses: bs.addresses,
        analytics: bs.analytics,
        actions: bs.actions,
        scraping: bs.scraping,
        settings: bs.settings,
        meterReadings: bs.meterReadings,
        notFound: bs.notFound,
        components: bs.components,
        status: bs.status,
        adminSettings: bs.adminSettings,
        setup: bs.setup,
        backendLogs: bs.backendLogs,
      },
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
